import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

/** Every "Book a Free Automation Assessment" button opens the booking page. */
export function useBookAssessment(): () => void {
  const navigate = useNavigate();
  return useCallback(() => navigate("/book"), [navigate]);
}
